export const CLICK_TYPE = {
  SELECT: 'SELECT',
  DESELECT: 'DESELECT',
};
